module.exports = __webpack_public_path__ + "static/media/rotate.8c5659f1.svg";